import React, { useEffect, useState } from 'react';
import '../../../styles/mainContents.css';
import { fetchManageUserThirdPartyEditLocPermission, fetchManageUserThirdPartyDeleteLoc, fetchUserThirdPartyPermissions, fetchManageUserDeleteCustomer, fetchManageUserAddCustomer, fetchUserCustomersPermissions, setAddConsignmentPopup, fetchConsignmentsProduct, fetchConsignmentsCustomer, fetchUserConsignmentsCustomers, fetchDeleteItemsRow, fetchEditItemsRow, fetchInsertItemsRow } from '../../../redux/actions/consignmentsPostActions';
import { fetchSubmitEditUser, adminFetchUsers, adminFetchCustomerPermissions } from '../../../redux/actions/AdminActions';
import { useDispatch, connect } from 'react-redux';
import ErrorHandlerAlert from '../../error/ErrorHandlerAlert';
import { Link, Switch, useHistory } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import { JsonWebTokenError } from 'jsonwebtoken';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import InsertItemModel from './InsertItemModel';
import ConsignmentHeader from '../../layout/ConsignmentHeader';
import AddCustToUser from './AddCustToUser';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import { Tooltip, IconButton } from '@mui/material';
import Select from 'react-select';
import AsyncCreatableSelect from 'react-select/async-creatable';

function ManageUsersConsignments(props) {

  const dispatch = useDispatch();
  const history = useHistory();

  const { allThirdPartyPermissionTypeState, fetch_manageUserThirdPartyEditLocPermission, fetch_manageUserThirdPartyDeleteLoc, fetch_UserThirdPartyPermissions, userThirdPartyState, fetch_manageUserDeleteCustomer, fetch_manageUserAddCustomer, fetch_adminFetchCustomerPermissions, fetch_submitEditUser, customerPermissionReducerState, userCustomerState, fetch_UserCustomersPermissions, fetch_adminFetchUsers, adminReducerState, fetch_ConsignmentsCustomer, authreducerState, fetch_ConsignmentsProduct, fetch_UserConsignmentsCustomers, fetch_deleteItemsRow, fetch_editItemsRow, consignmentsProductState, consignmentsCustState, userConsignmentsCustState } = props;

  useEffect( () => { 
    fetch_adminFetchUsers(authreducerState.user); 
    fetch_adminFetchCustomerPermissions(authreducerState.user);
  }, []);

  const [ addUseridState, setAddUseridState ] = useState({
    addUserid: '',
    addUsername: '',
  });

  const defaultItemModel = {
    showModel: false,
    custnoClicked: null,
    prdidClicked: null,
    partnoClicked: null
  };

  let [isDialogOpen, setIsDialogOpen] = useState({
    displayOpen: false,
    openedDataIndex: null
  })


  const [editCustnoSelectedState, setEditCustnoSelectedState] = useState({USERID:null, CUSTNO: ''})

  const [editUserThirdPartySelectedState, setEditUserThirdPartySelectedState] = useState({USERID:null, LOC: '', PERMISSION_TYPE: ''})
  const [editThirdPartyPermissionSelectedState, setThirdPartyPermissionSelectedState] = useState(null);


  const columnsOptions_userCustomer = (filterEnabled=false) => {
    
    return {
        filter: filterEnabled,
        sort: true,
    }
  };

  const options_userCustomer = {
    filterType: "checkbox",
    selectableRows: "none",
    onRowClick: (rowData, rowMeta) => {
      console.log('options_userCustomer clicked',rowData, rowMeta, rowData[0]);

      var custnoInput = rowData[0];

      // fetch_ConsignmentsCustomer({custnoInput: rowData[0]});
    },
    rowsPerPage: 200,
    tableBodyHeight: "500px",
  };

  const columns_userCustomer = [   
    {
      name: "CUSTNO",
      label: "Custno",
      options: columnsOptions_userCustomer(true),
    },
    {
      name: "CUSTNAME",
      label: "Custname",
      options: columnsOptions_userCustomer(),
    },    
    {
      name: "ADDR1",
      label: "Addr1",
      options: columnsOptions_userCustomer(),
    },  
    {
      name: "ADDR2",
      label: "Addr2",
      options: columnsOptions_userCustomer(),
    }, 
    {
      name: "CITY",
      label: "City",
      options: columnsOptions_userCustomer(),
    },   
    {
      name: "STATE",
      label: "State",
      options: columnsOptions_userCustomer(),
    },   
    {
      name: "ZIP",
      label: "Zip",
      options: columnsOptions_userCustomer(),
    },    
  ]


  const columnsOptions_usersRole = (colName='', inputType='text', filterEnabled=false, displayType=true, downloadType=true) => {
    var options = {};
    let maxValue = 1000;

    colName === '' ?
      options = {
        filter: filterEnabled,
        sort: true, 
        download: downloadType,
        display: displayType,        
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: "nowrap",
            position: "sticky",
            top: '0px',
            zIndex: 101,      
          }
        })               
      }
    :
    colName === 'manage' ?
      options = {
        filter: filterEnabled,
        sort: true,
        download: downloadType,
        display: displayType,         
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: "nowrap",
            position: "sticky",
            top: 0,
            zIndex: 101,            
          }
        }),            
        customBodyRenderLite: (dataIndex, rowIndex) => {

          
          return (
            <span>
              <button style={{marginRight:'12px'}} 
                onClick={ () => {

                  setIsDialogOpen({displayOpen: true, openedDataIndex: dataIndex});

                }}>EDIT<br/>USER</button>

              <button style={{marginRight:'12px'}} onClick={ () => {
                let userid = adminReducerState[dataIndex]['USERID'];      
                setEditUserThirdPartySelectedState({'USERID':userid, 'LOC': '', PERMISSION_TYPE: ''});

                fetch_UserThirdPartyPermissions(userid);
              }}>MANAGE<br/>3RD PARTY</button>
              
              <button onClick={ () => {
                // console.log('openedDataIndex][USERID]', adminReducerState[dataIndex]['USERID'])
                let userid = adminReducerState[dataIndex]['USERID'];      
                setEditCustnoSelectedState({'USERID':userid, 'CUSTNO': ''});

                fetch_UserCustomersPermissions(userid);
              }}>MANAGE<br/>CUST</button>

            </span>
          )
        }
    }
    :
      options = {
        filter: filterEnabled,
        sort: true,
        download: downloadType,
        display: displayType,         
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: "nowrap",
            position: "sticky",
            top: 0,
            zIndex: 101,            
          }
        }),            
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <span></span>
          )
        }
      }
    return options;
  }

  const columnsUsersRole = [
    {
      name: "USERID",
      label: "Userid",
      options: {
        filter: false,
        display: false, 
      }, 
    },    
    {
      name: "USERNAME",
      label: "Username",
      options: columnsOptions_usersRole('', 'text', false, true, true),
    },
    {
      name: "EMAIL",
      label: "Email",
      options: columnsOptions_usersRole('', 'text', false, true, true),
    },
    {
      name: "NAME",
      label: "Name",
      options: columnsOptions_usersRole('', 'text', false, true, true),
    },
    {
      name: "ROLE_NAME",
      label: "Role Name",
      options: columnsOptions_usersRole('', 'text', true, true, true),
    },   
    {
      name: "",
      label: "Manage",
      options: columnsOptions_usersRole("manage", 'text', false, true, true),
    },           
  ]

  const optionsUsersRole = {
    filterType: "checkbox",
    selectableRows: "none",
    responsive: "standard",
    onRowClick: (rowData, rowMeta) => {
      console.log("UsersRole optionsUsersRole onRowClick rowData:" + JSON.stringify(rowData) + " rowMeta:" + JSON.stringify(rowMeta));
      let userid = rowData[0];
      let username = rowData[1];

      // setAddUseridState({addUserid: userid, addUsername: username});

      
      // fetch_UserCustomersPermissions(userid);   
    },
    onChangePage (currentPage) {
      console.log({currentPage});
     
    },
    rowsPerPage: 200,
    tableBodyHeight: "500px",
  };  

  let EditUserDialog = () => {    
    // let editUserList = adminReducerState.map( (item,i) => { return { ...item, 'value': item['USERNAME'], 'label': item['USERNAME'] }; });
    const [editUserSelectedState, setEditUserSelectedState] = useState({USERID: null, EMAIL:'', NAME: '', ROLE_NAME: ''});
    
    let editPermissionList = customerPermissionReducerState.map( (item,i) => { return { 'value': item['PERMISSION_TYPE'], 'label': item['PERMISSION_TYPE'] }; });
    const [editPermissionSelectedState, setEditPermissionSelectedState] = useState(null);
    
    
    // console.log('isDialogOpen', isDialogOpen)
    // console.log('adminReducerState[isDialogOpen.openedDataIndex]', adminReducerState[isDialogOpen.openedDataIndex])
    // console.log('adminReducerState[isDialogOpen.openedDataIndex][USERID]', adminReducerState[isDialogOpen.openedDataIndex]['USERID'])

    return (
      isDialogOpen.displayOpen === true ? 
        <>
        
        {/* <Dialog maxWidth={'3'} onClose={() => { setIsDialogOpen(false); setClickedInvnoState(null); fetch_customerDetailReset(); dispatchSetRotateRequestState([]); dispatchSetNoRotatesNeededCbState(false); }} open={isDialogOpen}> */}
        <Dialog maxWidth={'3'} onClose={() => {  }} open={isDialogOpen.displayOpen}>
            
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" >
              <div style={ {fontWeight:'bold', textAlign:'left', minWidth:'100%', width: '400px', margin:'0', padding:'0'} }>Edit User </div>

            </DialogTitle>      
            <IconButton
              aria-label="close"
              //onClick={() => { setIsDialogOpen(false); setClickedInvnoState(null); fetch_customerDetailReset(); dispatchSetRotateRequestState([]); dispatchSetNoRotatesNeededCbState(false); }}
              onClick={() => { setIsDialogOpen({displayOpen:false, openedDataIndex: null});  }}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            
            <DialogContent dividers>
             
              { 
                (authreducerState.user.role_name === undefined) ? "" :                    
                (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ? "No access to submit user change" 
                :  
                  <React.Fragment>
                                       
                    <table id='editUserTbl'>
                      
                      <thead>
                        <tr>
                          <td colSpan={3}>
                            Username:<br/>
                            {adminReducerState[isDialogOpen.openedDataIndex]['USERNAME']}
                          </td>
                        </tr>
                      </thead>
                      <tbody>

                        <tr>
                          <td colSpan={3}>
                            <div className='edit-line-container'>
                              <span className="line"></span>
                              <span className="center-word">Edit</span>
                              <span className="line"></span>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>Email:</td>
                          <td>Name:</td>
                          <td>Role Name:</td>
                        </tr>
                        <tr>
                          <td>
                            <input id='adminEditEmailId' type="text" placeholder='EMAIL' 
                              key={'adminEditEmailKey'}
                              name={'adminEditEmailName'}
                              value={editUserSelectedState.EMAIL}
                              onChange={ (e) => {
                                setEditUserSelectedState({...editUserSelectedState, 'EMAIL': e.target.value.trim()});
                              }}
                            />
                          </td>
                          <td>
                            <input id='adminEditNameId' type="text" placeholder='NAME'
                              key={'adminEditNameKey'}
                              name={'adminEditNameName'}
                              value={editUserSelectedState.NAME}
                              onChange={ (e) => {
                                setEditUserSelectedState({...editUserSelectedState, 'NAME': e.target.value.trim()});
                              }}
                            />                            
                          </td>
                          <td>
                            <Select menuPosition="fixed" menuPlacement="top"
                              key={'editPermissionListKey'} 
                              options={ editPermissionList } 
                              value={editPermissionSelectedState }                             
                              onChange={ e => {
                                setEditPermissionSelectedState(e);
                                setEditUserSelectedState({...editUserSelectedState, 'ROLE_NAME': e.value, 'USERID': adminReducerState[isDialogOpen.openedDataIndex]['USERID'] });

                                console.log('editUserSelectedState',editUserSelectedState)
                              }
                            }/>
                                                      
                          </td>                                                                        
                        </tr>                        
                      </tbody>

                    </table>
                  </React.Fragment>                        

                    
              }           
            </DialogContent>
            


            <DialogActions>
              <Button onClick={(e) => 
                {   
                  // fetch_submitEditUser(editUserSelectedState, adminReducerState[isDialogOpen.openedDataIndex]['USERID']);
                  fetch_submitEditUser(editUserSelectedState, null );

                }}>
                Submit User Change
              </Button>
            </DialogActions>       
        </Dialog>
        </>
      : ''
    )

  }


  const columnsOptions_userThirdPartyPermission = (filterEnabled=false) => {
  
    return {
        filter: filterEnabled,
        sort: true,
    }
  }; 

  const columns_userThirdPartyPermission = [   
    {
      name: "USERID",
      label: "Userid",
      options: {
        filter: false,
        display: false, 
      }, 
    },          
    {
      name: "LOC",
      label: "LOC",
      options: columnsOptions_userThirdPartyPermission(),
    },    
    {
      name: "PERMISSION_TYPE",
      label: "PERMISSION_TYPE",
      options: columnsOptions_userThirdPartyPermission(),
    },  
  ]
  
  const options_userThirdPartyPermission= {
    filterType: "checkbox",
    selectableRows: "none",
    onRowClick: (rowData, rowMeta) => {
      console.log('options_userThirdPartyPermission clicked',rowData, rowMeta, rowData[0]);

      var useridInput = rowData[0];
    },
    rowsPerPage: 200,
    tableBodyHeight: "500px",
  };

 

  return (
    

    <div className="BatteryCN">
      {console.log('ManageUsersConsignments open editCustnoSelectedState.USERID', editCustnoSelectedState.USERID)}
      <main>

        <div>          
          <div>
            {!authreducerState.isLoggedIn ? (

              <React.Fragment>
                {history.push('/login')}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <ConsignmentHeader />
              </React.Fragment>
            )}


            <div id='usersTblId'>
              { adminReducerState !== undefined ?
                    adminReducerState.length > 0 ?
                      <div>
                        <MUIDataTable
                            title={"Manage User Consignment"}
                            data={adminReducerState}
                            columns={columnsUsersRole}
                            options={optionsUsersRole}
                        />
                      </div>

                        : ''
                    : 'adminReducerState undefined'
              }
            </div>

            <div className='userConsignmentsTblId'>
              {
                editCustnoSelectedState !== undefined ?
                  'USERID' in editCustnoSelectedState && editCustnoSelectedState.USERID !== null ?
                    <div id='addUserCustPageId'>
                      {/* {fetch_InventoryDetailPartnos(authreducerState.user, custnoDetailState.CUSTLOC)} */}
                      <div>
                        <div style={{padding:'0 32px 3px 0'}}>
                          <span style={{textDecoration:'underline', fontWeight:'bold'}}>Enter Custno</span> 
                          <div>
                            <input type="text" placeholder='NAME'
                              key={'custToAddToUserKey'}
                              name={'custToAddToUserName'}
                              value={editCustnoSelectedState.CUSTNO}
                              onChange={ (e) => {
                                setEditCustnoSelectedState({...editCustnoSelectedState, 'CUSTNO': e.target.value.trim()});
                              }}
                            />                            
                          </div>
                        </div>

                        <span style={{padding:'0 8px 0px 0'}}>
                          <button onClick={ () => {
                            fetch_manageUserDeleteCustomer(editCustnoSelectedState.USERID, editCustnoSelectedState.CUSTNO)                      
                          }}>DELETE<br/>CUST</button>
                        </span>                       

                        <span style={{padding:'0 8px 0px 0'}}>
                          <button onClick={ () => {                      
                            fetch_manageUserAddCustomer(editCustnoSelectedState.USERID, editCustnoSelectedState.CUSTNO)
                          }}>ADD<br/>CUST</button>

                        </span>
                      </div> 

                      {/* { <AddCustToUser useridToAddForCust={custnoDetailState.CUSTID} /> } */}

                    </div>
                    : ''
                : ''
              }

              { userCustomerState !== undefined ?
                    userCustomerState.length > 0 ?
                      <div>

                        <MUIDataTable
                            title={"User Consignment Customers Data"}
                            data={userCustomerState}
                            columns={columns_userCustomer}
                            options={options_userCustomer}
                        />
                      </div>

                        : ''
                    : 'userCustomerState undefined'
              }
            </div>
              
            <EditUserDialog/>



            <div className='userConsignmentsTblId'>
              {
                editUserThirdPartySelectedState !== undefined ?
                  'USERID' in editUserThirdPartySelectedState && editUserThirdPartySelectedState.USERID !== null ?
                    <div id='addUserThirdPartyPageId'>
                      <div>
                        <div style={{padding:'0 32px 3px 0'}}>
                          <div style={{fontWeight:'bold', fontSize: '32px'}}>Manage Loc for {
                          userThirdPartyState !== undefined ?
                            userThirdPartyState.length > 0 ?
                              userThirdPartyState[0].USERNAME : '' : ''}</div> 
                          <div>
                            <input type="text" placeholder='LOC'
                              key={'locToAddToUserKey'}
                              name={'locToAddToUserName'}
                              value={editUserThirdPartySelectedState.LOC}
                              onChange={ (e) => {
                                setEditUserThirdPartySelectedState({...editUserThirdPartySelectedState, 'LOC': e.target.value.trim()});
                              }}
                            />    
{/* 
                            <input type='checkbox'
                              name={'locToAddEditToUserCbName'}
                              checked={noRotatesNeededCbState}
                              onChange={(e) => {
                                if(noRotatesNeededCbState === false){
                                  dispatchSetNoRotatesNeededCbState(true);   
                                }
                                else{
                                  dispatchSetNoRotatesNeededCbState(false);                                                          
                                }
                              }}                              
                              // value={editUserThirdPartySelectedState.LOC}
                              // onChange={ (e) => {
                              //   setEditUserThirdPartySelectedState({...editUserThirdPartySelectedState, 'PERMISSION_TYPE': e.target.value.trim()});
                              // }}
                            />   */}

                            <Select menuPosition="fixed" menuPlacement="top"
                              key={'editPermissionListKey'} 
                              options={ allThirdPartyPermissionTypeState.map( (item,i) => { return { 'value': item['PERMISSION_TYPE'], 'label': item['PERMISSION_TYPE'] }; }) } 
                              value={editThirdPartyPermissionSelectedState }                             
                              onChange={ e => {
                                setThirdPartyPermissionSelectedState(e)
                                setEditUserThirdPartySelectedState({...editUserThirdPartySelectedState, 'PERMISSION_TYPE': e.value });
                              }
                            }/>                                                                               
                          </div>
                        </div>

                        <span style={{padding:'0 8px 0px 0'}}>
                          <button onClick={ () => {
                            fetch_manageUserThirdPartyDeleteLoc(editUserThirdPartySelectedState.USERID, editUserThirdPartySelectedState.LOC)                      
                          }}>DELETE<br/>LOC</button>
                        </span>                       

                        {/* <span style={{padding:'0 8px 0px 0'}}>
                          <button onClick={ () => {                      
                            // fetch_manageUserAddCustomer(editUserThirdPartySelectedState.USERID, editUserThirdPartySelectedState.LOC)
                          }}>ADD<br/>LOC</button>

                        </span> */}

                        <span style={{padding:'0 8px 0px 0'}}>
                          <button onClick={ () => {  
                            if(editUserThirdPartySelectedState.LOC === ''){
                              alert('NOTICE: Enter a location number to Add/Edit Loc Permission')
                            }      
                            else if(editUserThirdPartySelectedState.PERMISSION_TYPE === ''){
                              alert('NOTICE: Enter the permission type to Add/Edit Loc Permission')
                            }    
                            else{
                              fetch_manageUserThirdPartyEditLocPermission(editUserThirdPartySelectedState.USERID, editUserThirdPartySelectedState.LOC, editUserThirdPartySelectedState.PERMISSION_TYPE)
                            }          
                          }}>ADD/EDIT<br/>LOC PERMISSION</button>

                        </span>                        
                      </div> 

                      {/* { <AddCustToUser useridToAddForCust={custnoDetailState.CUSTID} /> } */}

                    </div>
                    : ''
                : ''
              }

              { userThirdPartyState !== undefined ?
                    userThirdPartyState.length > 0 ?
                      <div>

                        <MUIDataTable
                            title={"User Consignment 3rd Party Data"}
                            data={userThirdPartyState}
                            columns={columns_userThirdPartyPermission}
                            options={options_userThirdPartyPermission}
                        />
                      </div>

                        : ''
                    : 'userThirdPartyState undefined'
              }
            </div>


            {/* <InsertItemModel/> */}
          </div>
        </div>

      </main>


    </div>

  );
}


const mapStateToProps = (state) => {
 return {
    // consignmentsProductState: state.consignmentsPostReducer['items_fetchConsignmentsProduct'],
    // consignmentsCustState: state.consignmentsPostReducer['items_fetchConsignmentsCustomer'],
    userCustomerState: state.consignmentsPostReducer['items_fetchUserCustomer'],
    // addConsignmentPopup: state.consignmentsPostReducer['items_addConsignmentPopup'],  
    adminReducerState: state.adminReducer['adminUsers'],
    customerPermissionReducerState: state.adminReducer['customerPermissions'],
  
    userThirdPartyState: state.consignmentsPostReducer['items_fetchUserThirdParty'],
    allThirdPartyPermissionTypeState: state.consignmentsPostReducer['items_fetchAllThirdParty'],

    
    authreducerState: state.authreducer
 }
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetch_adminFetchUsers: (user) => {
      dispatch(adminFetchUsers(user));
    }, 
    fetch_adminFetchCustomerPermissions: (user) => {
      dispatch(adminFetchCustomerPermissions(user));
    }, 
    fetch_submitEditUser: (editedState) => {
      dispatch(fetchSubmitEditUser(editedState));
    },  
    fetch_manageUserAddCustomer: (userid, custnoInputState) => {
      dispatch(fetchManageUserAddCustomer(userid, custnoInputState));
    },  
    fetch_manageUserDeleteCustomer: (userid, custnoInputState) => {
      dispatch(fetchManageUserDeleteCustomer(userid, custnoInputState));
    },        

    // fetch_ConsignmentsCustomer: (custnoState) => {
    //     dispatch(fetchConsignmentsCustomer(custnoState));
    // },    
    fetch_UserCustomersPermissions: (userid, userCustOnly) => {
      dispatch(fetchUserCustomersPermissions(userid, userCustOnly));
    },
    // fetch_deleteItemsRow: (rowState, newConsignmentsCustState) => {
    //   dispatch(fetchDeleteItemsRow(rowState, newConsignmentsCustState));
    // },
    // fetch_editItemsRow: (rowState, newConsignmentsCustState) => {
    //   dispatch(fetchEditItemsRow(rowState, newConsignmentsCustState));
    // },     
    fetch_UserThirdPartyPermissions: (userid) => {
      dispatch(fetchUserThirdPartyPermissions(userid));
    },
    fetch_manageUserThirdPartyDeleteLoc: (userid, locInput) => {
      dispatch(fetchManageUserThirdPartyDeleteLoc(userid, locInput));
    },    
    fetch_manageUserThirdPartyEditLocPermission: (userid, locInput, permissionTypeInput) => {
      dispatch(fetchManageUserThirdPartyEditLocPermission(userid, locInput, permissionTypeInput));
    },        
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageUsersConsignments);